export const CATEGORIES = [
  "Node.js",
  "React",
  "Shopify",
  "Backend",
  "Frontend",
  "Remix",
  "Performance",
  "SEO",
  "Marketing",
  "DevOps",
  "Career",
];

export const CATEGORY_SLUGS = Object.fromEntries(
  CATEGORIES.map((c) => [c, c.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")])
);

export function categoryFromSlug(slug) {
  if (!slug) return "";
  const found = CATEGORIES.find((c) => CATEGORY_SLUGS[c] === slug);
  return found || "";
}
